import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { connect } from 'react-redux';
import { updateMessageContent } from '../../actions/nudgeActions';
import {
  AUTOCOMPLETE_OPTIONS,
  EDITOR_PLUGINS,
  EDITOR_API_KEY,
  EDITOR_MENU,
  CONTEXT_MENU_OPTIONS,
  QUICK_SELECTION_TOOLBAR,
  API_KEY,
} from '../../constants/editorConfig';
import { getEnvironmentStage } from '../../util/envUtils';

const RichTextEditor = props => {
  const editorChangeHandler = val => {
    const hasUpdates = Array.isArray(props.templateContent.contentElements);
    const updatedContentElements = hasUpdates ? [...props.templateContent?.contentElements] : [];
    const selectedContentElement = updatedContentElements
      .filter(contentElement => contentElement.id === props.templateContent?.selectedContentId)
      .at(0);
    if (selectedContentElement) {
      selectedContentElement.content = val;
      props.updateMessageContentAction(updatedContentElements);
    }
  };

  const onInitHandler = (event, editor) => {
    const specialChars = AUTOCOMPLETE_OPTIONS;
    let onAction = (autocompleteApi, rng, value) => {
      editor.selection.setRng(rng);
      editor.insertContent(value);
      autocompleteApi.hide();
    };

    let getMatchedChars = () => {
      return specialChars;
    };
    editor.ui.registry.addAutocompleter('specialchars_cardmenuitems', {
      ch: '{',
      minChars: 1,
      columns: 1,
      highlightOn: ['char_name'],
      onAction: onAction,
      fetch: pattern => {
        return new tinymce.util.Promise(resolve => {
          let results = getMatchedChars().map(char => {
            return {
              type: 'cardmenuitem',
              value: char.value,
              label: char.text,
              items: [
                {
                  type: 'cardcontainer',
                  direction: 'vertical',
                  items: [
                    {
                      type: 'cardtext',
                      text: char.value,
                      name: 'char_name',
                    },
                  ],
                },
              ],
            };
          });
          resolve(results);
        });
      },
    });
  };

  return (
    <Editor
      data-testid="rt_editor"
      apiKey={API_KEY[getEnvironmentStage()]}
      height={'40%'}
      init={{
        menubar: EDITOR_MENU,
        plugins: EDITOR_PLUGINS,
        toolbar: props.toolbar,
        toolbar_mode: 'sliding',
        noneditable_noneditable_class: 'mceNonEditable',
        contextmenu: CONTEXT_MENU_OPTIONS,
        // skin: useDarkMode ? 'oxide-dark' : 'oxide',
        content_css: 'default',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        image_caption: true,
        quickbars_selection_toolbar: QUICK_SELECTION_TOOLBAR,
        noneditable_noneditable_class: 'mceNonEditable',
      }}
      onInit={(evt, editor) => onInitHandler(evt, editor)}
      onEditorChange={val => {
        editorChangeHandler(val);
      }}
      value={props.value}
    />
  );
};

const mapStateToProps = state => ({
  templateContent: state.createContent,
});

const mapDispatchToProps = {
  updateMessageContentAction: updateMessageContent,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RichTextEditor);
